var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureIcon06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-90%",
    y: "-90%",
    width: "280%",
    height: "280%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 .856h63.533v59.675H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "56.146%",
    y1: "10.87%",
    x2: "25.695%",
    y2: "72.649%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3039",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A94A7",
    offset: "48.131%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3039",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.062.344h40.511v44.1H.062z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.892%",
    y1: ".428%",
    x2: "24.856%",
    y2: "100%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B404C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333843",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0270D7",
    d: "M23.302 63.083L.112 44.995l73.273-31.416 23.19 18.091z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00BFFB",
    d: "M35.902 83.663l1.17-6.562-16.24 4.895-1.17 6.563z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.32,
    fill: "#00BFFB",
    d: "M41.972 92.478l-2.962 3.376 11.56 2.714 2.961-3.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.48,
    fill: "#1D2026",
    filter: "url(#a)",
    d: "M36.056 33.707h40v40h-40z",
    transform: "rotate(16 55.276 48.942)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(16 -28.89 116.929)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.628 40.394c.06-.485.116-.972.204-1.45.055-.295.135-.583.2-.874.096-.427.181-.856.296-1.276.084-.303.192-.596.286-.894.128-.401.246-.808.393-1.202.05-.141.113-.275.169-.414.195-.5.4-.997.624-1.483.103-.22.214-.434.322-.65a28.007 28.007 0 0 1 2.005-3.412c.07-.1.15-.192.219-.29.448-.622.922-1.222 1.418-1.801.172-.198.347-.391.523-.584.464-.508.946-.993 1.444-1.46.175-.162.343-.334.522-.493.13-.113.263-.22.392-.332a25.56 25.56 0 0 1 1.147-.91c.146-.11.291-.22.44-.325.356-.254.723-.49 1.093-.723.212-.134.42-.276.637-.402.428-.252.868-.48 1.311-.702.157-.08.307-.169.465-.244a22.326 22.326 0 0 1 1.727-.721c.162-.06.326-.111.49-.168.45-.155.905-.293 1.366-.417.178-.047.354-.097.532-.14a20.012 20.012 0 0 1 1.862-.362 18.96 18.96 0 0 1 1.675-.155c.175-.01.347-.008.52-.013.382-.008.76-.008 1.134.005a17.935 17.935 0 0 1 1.654.144c.174.022.347.042.518.07.44.071.874.161 1.301.266.075.019.154.03.229.05.508.132 1.003.29 1.49.467.143.05.28.11.42.166.347.136.691.282 1.025.44.288.135.575.268.852.419L31.118 2.89a18.16 18.16 0 0 0-.619-.319c-.075-.038-.156-.065-.233-.1-.337-.16-.68-.305-1.028-.442-.14-.055-.276-.115-.417-.165-.49-.176-.985-.335-1.493-.466l-.03-.01c-.063-.016-.13-.024-.192-.04-.43-.105-.865-.195-1.307-.267-.17-.027-.344-.047-.518-.07a17.934 17.934 0 0 0-1.654-.144 17.699 17.699 0 0 0-1.133-.004c-.174.004-.346.003-.52.012-.554.03-1.112.076-1.678.155a20.56 20.56 0 0 0-1.86.364c-.178.04-.355.09-.532.139-.46.122-.917.262-1.368.417-.162.055-.326.106-.488.168-.566.209-1.126.436-1.674.694l-.054.027c-.155.074-.304.162-.458.24a22.56 22.56 0 0 0-1.318.705c-.215.127-.421.268-.633.401-.276.174-.558.338-.826.524-.093.064-.181.135-.272.2-.148.106-.293.217-.438.325-.39.291-.77.594-1.145.91-.132.112-.264.219-.394.333-.065.058-.136.11-.2.169-.113.102-.21.22-.32.324-.5.465-.982.952-1.445 1.46-.097.106-.208.197-.303.304-.079.09-.143.19-.22.281a26.06 26.06 0 0 0-1.42 1.8c-.057.08-.125.152-.182.233-.013.018-.023.038-.036.057a26.58 26.58 0 0 0-1.459 2.366c-.047.087-.108.167-.156.253-.138.26-.26.528-.391.792-.107.217-.218.43-.32.65-.225.485-.43.98-.625 1.481-.054.14-.118.276-.17.417l-.029.07c-.135.368-.242.749-.361 1.126-.094.3-.204.594-.287.899-.119.425-.204.859-.3 1.29-.065.287-.143.57-.197.86-.09.484-.145.974-.205 1.463-.03.247-.08.488-.102.734-.07.74-.107 1.485-.108 2.233-.014 7.778 3.736 14.079 9.395 17.158L41.813 60.53c-5.66-3.08-9.41-9.38-9.395-17.156.001-.75.037-1.495.107-2.235.024-.25.072-.496.103-.746",
    fill: "url(#c)",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(16 -109.581 222.973)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.358.531C31.545-1.04 40.595 7.473 40.574 19.548c-.023 12.075-9.11 23.137-20.297 24.71C9.09 45.83.04 37.316.062 25.24.084 13.166 9.172 2.103 20.358.531",
    fill: "url(#f)",
    mask: "url(#g)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#02CBB1",
    d: "M114.324 47.62l-10.196-8.59-7.761 33.025 10.197 8.59z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon06);
export default __webpack_public_path__ + "static/media/feature-icon-06.f099c6bbf2c755947af79fba0269bf94.svg";
export { ForwardRef as ReactComponent };